import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, ArrowLeft, RefreshCw } from 'lucide-react';
import { supabase } from '../../config/supabase';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import './Login.css';

export default function EmailVerification() {
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  useDocumentTitle('Verify Email');

  // Get email from URL params or sessionStorage
  const params = new URLSearchParams(window.location.search);
  const email = params.get('email') || sessionStorage.getItem('pendingVerificationEmail') || '';

  const handleResend = async () => {
    if (!email || resending) return;
    setResending(true);
    setError(null);

    try {
      const { error: resendError } = await supabase.auth.resend({
        type: 'signup',
        email,
        options: {
          emailRedirectTo: `${window.location.origin}/auth/callback`,
        },
      });
      if (resendError) throw resendError;
      setResent(true);
      setTimeout(() => setResent(false), 30000); // Reset after 30s
    } catch (err) {
      setError(err.message || 'Failed to resend verification email.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="email-verify-icon">
          <Mail size={40} />
        </div>

        <div className="login-header">
          <h1 className="login-title" style={{ fontSize: '24px' }}>Check your email</h1>
          <p className="login-subtitle">
            {email ? (
              <>We sent a verification link to <strong style={{ color: 'var(--color-text)' }}>{email}</strong></>
            ) : (
              'We sent a verification link to your email address.'
            )}
          </p>
        </div>

        <div className="email-verify-instructions">
          <p>Click the link in the email to verify your account. If you don't see it, check your spam folder.</p>
        </div>

        {error && (
          <div className="email-verify-alert email-verify-error">
            <p>{error}</p>
          </div>
        )}

        {resent && (
          <div className="email-verify-alert email-verify-success">
            <p>Verification email resent successfully.</p>
          </div>
        )}

        <div className="email-verify-actions">
          {email && (
            <button
              className="login-button"
              onClick={handleResend}
              disabled={resending || resent}
            >
              <RefreshCw size={16} className={resending ? 'spinning' : ''} />
              {resending ? 'Sending...' : resent ? 'Email Sent' : 'Resend Verification Email'}
            </button>
          )}

          <button
            className="login-button oauth-button"
            onClick={() => navigate('/login')}
          >
            <ArrowLeft size={16} />
            Back to Sign In
          </button>
        </div>
      </div>
    </div>
  );
}
